
export default {
    name: 'coursestoremanagement',
    //进入的是什么管理系统
    data() {
        return {
            // 店铺的名字
            store: '',
            // 店铺id
            shop_id: this.$store.state.shopId,
            // 权限对象
            authorizationObject: {},
            // 课程管理
            courseManagement: null,
            // 资源管理
            resourceManagement: null,
            // 项目包管理
            projectPackageManagement: null,
            // 订单管理
            orderManagement: null,
            // 班级管理
            classManagement: null,
            // 学员管理
            studentManagement: null,
            // 余额管理
            balanceManagement: null,
            // 发布管理
            releaseManagement: null,
            // 权限用户的名字
            name: '',
            // 控制显示修改密码弹窗
            dialogVisible: false,
            // 旧密码
            oldPwd: '',
            // 新密码
            newPwd: '',
            // 确认密码
            rePwd: '',
        }
    },
    methods: {
        toclassorder: function () {
            this.$router.push({
                path: '/classorder',
            })
        },
        //回到个人中心
        loginOut: function () {
            // // console.log(111111111);

            this.$router.push({
                path: '/personalcenter'
            })
        },

        // 获取课程管理权限
        getCourseManagement() {
            let obj = this.authorizationObject
            this.courseManagement = obj.course_product_list || obj.activity_management
        },

        // 获取资源管理权限
        getResourceManagement() {
            let obj = this.authorizationObject
            this.resourceManagement = obj.label_management || obj.labels_to_choose || obj.image_resources || obj.video_resources
                || obj.document_resources || obj.audio_resources || obj.test_resources || obj.homework_problems || obj.discussion_topic_resources
        },

        // 获取项目包管理权限
        getProjectPackageManagement() {
            let obj = this.authorizationObject
            this.projectPackageManagement = obj.itemized_product_list || obj.project_package_property_management || obj.project_package_management
        },

        // 获取订单管理权限
        getOrderManagement() {
            let obj = this.authorizationObject
            this.orderManagement = obj.order || obj.cancel_the_order || obj.invoice || obj.export_purchase_record
        },

        // 获取班级管理权限
        getClassManagement() {
            let obj = this.authorizationObject
            this.classManagement = obj.class_management || obj.counselor_management || obj.workload_statistics
        },

        // 获取学员管理权限
        getStudentManagement() {
            let obj = this.authorizationObject
            this.studentManagement = obj.student_management || obj.cz_management || obj.credit_hours_management || obj.bulk_registration
                || obj.batch_elective || obj.batch_classes || obj.batch_revision_year
        },

        // 获取余额管理权限
        getBalanceManagement() {
            let obj = this.authorizationObject
            this.balanceManagement = obj.balance_recharge || obj.balance_record
        },

        // 获取发布管理权限
        getReleaseManagement() {
            let obj = this.authorizationObject
            this.releaseManagement = obj.shuffling_figure || obj.sector_management || obj.navigation_bar_management || obj.announcements
                || obj.news_center
        },

        // 获取所有权限
        getAll() {
            this.getCourseManagement()
            this.getResourceManagement()
            this.getProjectPackageManagement()
            this.getOrderManagement()
            this.getClassManagement()
            this.getStudentManagement()
            this.getBalanceManagement()
            this.getReleaseManagement()
        },

        // 获取权限用户信息
        getInfo() {
            this.$post('authority_management_user/get_info', {
                token: sessionStorage.getItem('authid')
            }).then(res => {
                if (res.status === 200) {
                    this.name = res.data.result.name
                }
            })
        },

        // 退出登录
        loginOut() {
            this.$confirm('确认退出登录吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                sessionStorage.removeItem('authid')
                sessionStorage.removeItem('authorizationObject')
                this.$store.state.activity_management = null
                this.$router.push({
                    path: '/authority_management_login'
                })
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '取消退出登录'
                })
            })
        },

        // 修改密码
        changePwd() {
            let { oldPwd, newPwd, rePwd } = this;
            // 验证
            if (oldPwd == '') {
                this.$message.error('请输入旧密码');
                return;
            } else if (newPwd == '') {
                this.$message.error('请输入新密码');
                return;
            } else if (rePwd == '') {
                this.$message.error('请输入确认密码');
                return;
            } else if (newPwd != rePwd) {
                this.$message.error('两次密码不一致');
                return;
            } else if (newPwd.length < 6) {
                this.$message.error('新密码长度至少六位');
            }
            this.confirmChangePwd();
        },

        // 确定修改密码
        confirmChangePwd() {
            this.$post('/authority_management_user/alterPassword', {
                token: this.$store.state.authority_management,
                oldPassword: this.oldPwd,
                newPassword: this.newPwd
            }).then(res => {
                if (res.data.status == 'success') {
                    this.dialogVisible = false;
                    this.$message.success('修改成功，请重新登录');
                    sessionStorage.removeItem('authorInfo');
                    sessionStorage.removeItem('authid');
                    sessionStorage.removeItem('authorizationObject');
                    this.$store.state.activity_management = null
                    this.$router.push({
                        path: '/authority_management_login'
                    })
                } else if (res.data.status == 'fail') {
                    this.$message.error(res.data.errorMsg[0]);
                } else {
                    this.$message.error('修改失败，请稍后重试！');
                }
            }).catch(error => {
                console.log(error);
            });
        }
    },
    created() {
        this.$post('shops/get_shopid', { id: this.$store.state.store.id }).then(res => {
            document.title = res.data.result.platform_name;
            this.store = res.data.result.platform_name;
        })
        this.manageType = this.$route.query.type;
        // document.title=this.$store.state.store.platform_name;

        // 从缓存中获取用户权限信息
        this.authorizationObject = JSON.parse(sessionStorage.getItem('authorizationObject'))

        // 获取所有
        this.getAll()

        // 获取权限用户信息
        this.getInfo()

    }
}
